"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCATION_DENIED_CODE = void 0;

/* Error code returned from Geolocation.getCurrentPosition()
if the user denies access. */
var LOCATION_DENIED_CODE = 1;
exports.LOCATION_DENIED_CODE = LOCATION_DENIED_CODE;
//# sourceMappingURL=constants.js.map